/** Modal styles for react-modal (register completion). Evaluated once at module load. */
const baseContent = {
  top: "50%",
  left: "50%",
  right: "auto",
  bottom: "auto",
  marginRight: "-50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "30px",
  backgroundColor: "#ffffff",
};

const overlay = {
  backgroundColor: "rgba(0, 0, 0, 0.2)",
  zIndex: 1000,
};

const mediaMatch =
  typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(max-width: 850px)")
    : { matches: false };

export const patientInitiationRegisterModalStyles = {
  content: {
    ...baseContent,
    width: mediaMatch.matches ? "70%" : "37%",
  },
  overlay,
};
